import React, { Component } from 'react'
import LandingPageFrame from './LandingPageFrame'
import StoryContent from './StoryContent'

export default class Story extends Component {
  render () {
    return (
      <LandingPageFrame>
        <StoryContent />
      </LandingPageFrame>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/landing-elements/Story.js